import _ from 'lodash'
import Backbone from 'backbone'

/*
 * A parent for different snap types
 */
var Snap = Backbone.View.extend({

  threshold: 7, // objects comes within this range of some coord, then snap

  initialize: function (options) {
    this.canvas = options.canvas
  },

  withinThreshold: function (coord, threshold) {
    if (threshold == null) {
      threshold = this.threshold
    }
    return coord > -threshold && coord < threshold
  },

  /*
   * Returns if two shape, obj1 and obj2, intersect on a horizontal plane
   */
  horizontalIntersect: function (obj1, obj2) {
    return obj2.top + obj2.height >= obj1.top && obj2.bottom - obj2.height <= obj1.bottom
  },

  getGuides: function () {
    return []
  },

  /*
   * Returns if two shape, obj1 and obj2, intersect on a vertical plane
   */
  verticalIntersect: function (obj1, obj2) {
    return obj2.left + obj2.width >= obj1.left && obj2.right - obj2.width <= obj1.right
  },

  setBounds: function (area) {
    area.right = area.left + area.width
    area.bottom = area.top + area.height
    return area
  },

  areas: function (currentArea) {
    var areas = [currentArea]
      , self = this

    this.canvas.collection.each(function (wob) {
      if (_.indexOf(self.canvas.selection.wobs, wob) < 0) {
        var bb = wob.boundingBox()
        areas.push(bb)
      }
    })

    // Make sure we have `right` and `bottom` properties on the objects
    return areas.map(this.setBounds)
  }

})

export default Snap
